import React from 'react';
import '../../../components/layout/ModuleLayout.css';
import ComplianceInsights from '../../../components/compliances/ComplianceInsights';
import ComplianceFilings from '../../../components/compliances/ComplianceFilings';
import ComplianceLitigations from '../../../components/compliances/ComplianceLitigations';
import ComplianceBacklog from '../../../components/compliances/ComplianceBacklog';
import ComplianceUnattended from '../../../components/compliances/ComplianceUnattended';
import CadenceRuleList from '../../../components/cadence/CadenceRuleList';
import { CADENCE_MODULE_TYPES } from '../../../components/cadence/cadenceModuleTypes';
import { CompTabKey } from './ComplianceTabs';

interface ComplianceNetBodyProps {
  activeTab?: CompTabKey;
}

const ComplianceNetBody: React.FC<ComplianceNetBodyProps> = ({ activeTab = 'insights' }) => {
  const renderPanel = () => {
    if (activeTab === 'insights')    return <ComplianceInsights />;
    if (activeTab === 'filings')     return <ComplianceFilings />;
    if (activeTab === 'litigations') return <ComplianceLitigations />;
    if (activeTab === 'backlog')     return <ComplianceBacklog />;
    if (activeTab === 'unattended')  return <ComplianceUnattended />;
    if (activeTab === 'cadence')     return <CadenceRuleList allowedTypeCodes={CADENCE_MODULE_TYPES.compliance} />;
    return null;
  };

  return (
    <div className="module-layout" >
      <div className="module-main"  >
        <div className="tab-content"  >
          <section role="tabpanel" className="tab-panel show" >
            {renderPanel()}
          </section>
        </div>
      </div>
    </div>
  );
};

export default ComplianceNetBody;
